import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { LoanOdAccounts } from './loan-od-accounts.model';
import { LoanOdAccountsService } from './loan-od-accounts.service';
import { AlertService } from 'ng-jhipster';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class LoanOdAccountsRepaymentResolve implements Resolve<any> {

    constructor(private loanOdAccountsService: LoanOdAccountsService, private alertService: AlertService,
        private router: Router) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        if (route.paramMap.get('accountId')) {
            return this.loanOdAccountsService.repayEntry(route.paramMap.get('accountId')).pipe(map(
                (res) => { return res; }
            )).pipe(catchError(
                (err) => {
                    this.onSaveError(err);
                    return of(null);
                }
            ));
        } else {
            return new LoanOdAccounts();
        }
    }

    private onSaveError(error) {
        try {
            const errorString = error.error.localizedMessage;
            if (errorString) {
                this.alertService.error(errorString);
            } else {
                this.onError(error);
            }
        } catch (exception) {
            try {
                const errorString = error.error.text();
                if (errorString) {
                    this.alertService.error(errorString);
                } else {
                    this.onError(error);
                }
            } catch (exception) {
                this.onError(error);
            }
        }
        this.router.navigate(['/loan-od-accounts']);
    }
    private onError(error) {
        this.alertService.error(error.error);
    }
}
